import JoditEditor from "jodit-react";
import { Col, Row } from "../../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../../Buttons/MainButton";
import { useFetch, usePOST } from "../../../../ApiS";
import Title from "../../../Title/Title";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../../../Inputs/Input";
import Loader from "../../../Loader";
import { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { AxiosError } from "axios";

interface EditProgramRules {
  _method?: string;
  title_ar?: string;
  title_en?: string;
  description_ar?: string;
  description_en?: string;
}
type Error = {
  title_ar?: string[];
  title_en?: string[];
  description_ar?: string[];
  description_en?: string[];
};

export default function EditProgramRules() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [errors, setErrors] = useState<Error>({});
  const onError = (error: AxiosError<{ errors: Error; message: string }>) => {
    toast.dismiss("loading");
    toast.error(error.response?.data?.message);
    setErrors(errors);
  };

  const initalData: EditProgramRules = { _method: "PUT" };

  const { data, isLoading } = useFetch(
    `admin/program-rules/${id}`,
    `admin/program-rules/${id}`
  );

  const {
    handleChangeInput,
    handleSubmit,
    setFormData,
    formData,
    viewFiles,
    mutation,
  } = usePOST(
    initalData,
    () => {
      navigate("/infomation_application/program_role");
    },
    (error) => {
      onError(error);
    }
  );

  const validate = () => {
    const keysToCheck = Object.keys(formData).filter(
      (key) => key !== "_method"
    ) as (keyof EditProgramRules)[];

    let isValid;

    if (keysToCheck.length > 0 || viewFiles.length > 0) {
      isValid = id
        ? keysToCheck.some((key) => !!initalData[key])
        : keysToCheck.length >= 6;
    } else isValid = false;
    return isValid;
  };

  const toastId = useRef<string | number | null>(null);

  useEffect(() => {
    if (mutation.isLoading && !toast.isActive(toastId.current!)) {
      toastId.current = toast.loading("جاري التحميل...", {
        position: "bottom-left",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: false,
        progress: undefined,
      });
    } else if (!mutation.isLoading && toastId.current && !mutation.isError) {
      toast.update(toastId.current, {
        render: "تم التحميل بنجاح!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      toastId.current = null;
    } else if (mutation.isError) {
      toast.update(toastId.current!, {
        render: "هناك خطأ في عملية التعديل",
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      toastId.current = null;
    }
  }, [mutation.isLoading, mutation.isError]);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <ToastContainer position="bottom-left" />
      <Row>
        <Title title="تعديل قواعد البرنامج" />
      </Row>

      <Row justify={"center"} className="!mt-8 ">
        <Col lg={10} sm={10}>
          <h1 className="mb-4 text-2xl text-black font-bold">
            وصف العنوان باللغة العربية
          </h1>

          <Input
            defaultValue={data?.data?.title_ar}
            name="title_ar"
            onChange={handleChangeInput}
          />
          {errors?.title_ar &&
            errors?.title_ar.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={10} sm={10}>
          <h1 className="mb-4 text-2xl text-black font-bold">
            وصف العنوان باللغة الانكليزية
          </h1>

          <Input
            defaultValue={data?.data?.title_en}
            name="title_en"
            onChange={handleChangeInput}
          />
          {errors?.title_en &&
            errors?.title_en.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={10} sm={10}>
          <h1 className="mb-4 text-2xl text-black font-bold">
            وصف الوصف باللغة العربية
          </h1>

          <JoditEditor
            value={data?.data?.description_ar}
            onChange={(e) => setFormData({ ...formData, description_ar: e })}
          />
          {errors?.description_ar &&
            errors?.description_ar.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
        <Col lg={10} sm={10}>
          <h1 className="mb-4 text-2xl text-black font-bold">
            وصف العنوان باللغة الانكليزية
          </h1>

          <JoditEditor
            value={data?.data?.description_en}
            onChange={(e) => setFormData({ ...formData, description_en: e })}
          />
          {errors?.description_en &&
            errors?.description_en.map((error, index) => (
              <p key={index} className="text-red-600 text-sm" dir="auto">
                {error}
              </p>
            ))}
        </Col>
      </Row>
      {mutation.isLoading && <Loader />}
      <Col className="flex justify-evenly !mt-4 ">
        <Col lg={3} md={5} sm={4}>
          <MainButton
            titlebtn="تعديل"
            className="w-full"
            onClick={() => handleSubmit(`admin/program-rules/${id}`)}
          />
        </Col>

        <Col lg={3} md={5} sm={4}>
          <MainButton
            titlebtn="الغاء"
            className="w-full !bg-gray-200 !text-Secondary"
            onClick={() => navigate(-1)}
          />
        </Col>
      </Col>
    </>
  );
}
